import { ReportInput } from "./reports";
import { OrderDirection } from "./ticket";

export interface CoreTrackingIndexDto {
    id: string;
    partId: string;
    coreTrackingId: string;
    ticketItemId: string;
    ticketId: string;
    inventoryStockId?: string | undefined;
    invoiceNumber: number;
    invoiceDate: Date | undefined;
    partNumber: string;
    description: string;
    coreValue: number;
    totalQty: number;
    returnedQty: number;
    returned: boolean;
    refundedQty: number;
    refunded: boolean;
    vendorId?: string;
    vendorName?: string;
}

export interface SearchCoreTrackingIndex {
    invoiceNumber?: number;
    invoiceDate?: Date | undefined;
    partNumber?: string;
    description?: string;
    returned?: boolean;
    refunded?: boolean;
}

export enum CoreTrackingFilterBy {
    CreatedDate = 0,
    ReturnDate = 1,
    RefundDate = 2,
    InvoiceDate = 3
}

export interface CoreTrackingReportItemDto {
    id: string;
    ticketItemId?: string | undefined;
    ticketId?: string | undefined;
    partId: string;
    inventoryStockId?: string | undefined;
    vendorId?: string | undefined;
    vendorName: string;
    invoiceDate?: string | undefined;
    invoiceNumber?: number | undefined;
    partNumber: string;
    partDescription: string;
    quantity: number;
    returned: boolean;
    returnedQty: number;
    refunded: boolean;
    refundedQty: number;
    coreValue: number;
}

export interface CoreTrackingReportDTO extends ReportInput {
    filterBy: CoreTrackingFilterBy;
    orderBy: OrderDirection;
}